function stableStringifyReplacer(_, value) {
  // eslint-disable-next-line no-nested-ternary
  return isObject(value)
    ? Object.assign(
        {},
        ...Object.keys(value)
          .sort()
          .map(key => ({
            [key]: value[key],
          })),
      )
    : Array.isArray(value)
    ? value
    : String(value);
}

function stableStringify(obj) {
  return JSON.stringify(obj, stableStringifyReplacer);
}

function isObject(a) {
  return a && typeof a === 'object' && !Array.isArray(a);
}

export default stableStringify;
